module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/modules/_fails.js
// module id = 557
// module chunks = 3